import React from 'react';
import IconLink from "./IconLink";
import {Box, Typography, Chip, Button} from "@mui/material";

function PortfolioBlock(props) {
   const {image, live, source, title, description, tags, links, featured} = props;
   
   if (featured) {
       return (
          <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} mb={{xs: '2rem', md: '4rem'}}>
             {/* The CSS Mockup */}
             {Array.isArray(image) && image.length === 2 ? (
                <Box width="100%" display="flex" justifyContent="center" pl={{xs: 3, sm: 7}} pr={{xs: 1, sm: 5}}>
                   <Box position="relative" width={{xs: '92%', sm: '80%'}} maxWidth="410px" margin={{xs: "1rem auto 3.5rem auto", sm: "1.5rem auto 4.5rem auto"}}>
                      {/* Laptop Screen */}
                      <Box position="relative" border="10px solid #2b2b2b" borderBottom="none" borderRadius="12px 12px 0 0" overflow="hidden" boxShadow="0 20px 40px rgba(0,0,0,0.12)" background="#000">
                         <Box component={'img'} src={image[0]} alt={'desktop mockup'} style={{ width: '100%', display: 'block', aspectRatio: '16/9', objectFit: 'cover', objectPosition: 'top' }} />
                      </Box>
                      {/* Laptop Base */}
                      <Box height="14px" background="#e0e0e0" borderRadius="0 0 14px 14px" position="relative" width="116%" left="-8%" boxShadow="inset 0 -3px 6px rgba(0,0,0,0.1), 0 15px 25px rgba(0,0,0,0.15)">
                         <Box position="absolute" top="0" left="50%" sx={{transform: 'translateX(-50%)'}} width="70px" height="5px" background="#b5b5b5" borderRadius="0 0 5px 5px" />
                      </Box>
       
                      {/* Mobile Phone Screen */}
                      <Box position="absolute" bottom="-15%" left="-8%" width="22%" minWidth="65px" border="5px solid #2b2b2b" borderRadius="18px" overflow="hidden" boxShadow="-10px 20px 30px rgba(0,0,0,0.15)" background="#000" zIndex={2}>
                         <Box component={'img'} src={image[1]} alt={'mobile mockup'} style={{ width: '100%', display: 'block', aspectRatio: '9/19.5', objectFit: 'cover', objectPosition: 'top' }} />
                         <Box position="absolute" top="0" left="50%" sx={{transform: 'translateX(-50%)'}} width="40%" height="10px" background="#2b2b2b" borderRadius="0 0 6px 6px" />
                      </Box>
                   </Box>
                </Box>
             ) : (
                 <Box component={'img'} src={Array.isArray(image) ? image[0] : image} alt={'mockup'} style={{ maxWidth: '100%', objectFit: 'contain', maxHeight: '40vh', borderRadius: '15px' }} mb={{xs: '1.5rem', md: '2rem'}}/>
             )}
             
             {/* Content */}
             <Box display={'flex'} flexDirection={'column'} alignItems={'center'} textAlign={'center'} px={{xs: 2, md: 4}}>
                <Typography variant="h4" fontWeight="700" gutterBottom sx={{ fontSize: {xs: '1.4rem', md: '1.8rem'}, letterSpacing: '-0.5px', color: '#111' }}>
                    {title}
                </Typography>
                
                {description && (
                    <Typography variant="body1" sx={{ maxWidth: '600px', mb: {xs: 1.5, md: 2.5}, lineHeight: 1.6, fontSize: {xs: '0.85rem', md: '0.95rem'}, color: '#666' }}>
                        {description}
                    </Typography>
                )}
                
                {tags && tags.length > 0 && (
                    <Box display="flex" gap={1} flexWrap="wrap" justifyContent="center" mb={{xs: 2.5, md: 3.5}}>
                        {tags.map((tag, idx) => (
                            <Chip key={idx} label={tag} size="small" sx={{ fontWeight: 500, backgroundColor: '#f5f5f7', color: '#555', fontSize: {xs: '0.65rem', md: '0.75rem'}, borderRadius: '6px' }} />
                        ))}
                    </Box>
                )}
                
                {links && links.length > 0 && (
                    <Box display={'flex'} flexDirection={'row'} gap={{xs: '0.5rem', md: '0.8rem'}} flexWrap={{xs: 'wrap', md: 'nowrap'}} justifyContent={'center'} alignItems={'center'} width="100%">
                        {links.map((item, index) => {
                            if (item.type === 'primary') {
                                return (
                                    <Button key={index} variant="contained" href={item.link} target="_blank" disableElevation
                                        sx={{ borderRadius: '50px', px: {xs: 2, md: 2.5}, py: {xs: 0.5, md: 0.7}, textTransform: 'none', fontWeight: 600, fontSize: {xs: '0.75rem', md: '0.85rem'}, backgroundColor: '#111', color: '#fff', '&:hover': { backgroundColor: '#333' }, transition: 'all 0.2s ease', minWidth: 'max-content' }}>
                                        {item.icon && <i className={item.icon} style={{ marginRight: '6px' }}/>} {item.title}
                                    </Button>
                                );
                            } else {
                                return (
                                    <Button key={index} variant="outlined" href={item.link} target="_blank"
                                        sx={{ borderRadius: '50px', px: {xs: 1.5, md: 2}, py: {xs: 0.4, md: 0.6}, textTransform: 'none', fontWeight: 500, fontSize: {xs: '0.75rem', md: '0.85rem'}, borderWidth: '1px', borderColor: '#e0e0e0', color: '#666', '&:hover': { borderColor: '#111', backgroundColor: 'transparent', color: '#111' }, transition: 'all 0.2s ease', minWidth: 'max-content' }}>
                                        {item.icon && <i className={item.icon} style={{ marginRight: '5px' }}/>} {item.title}
                                    </Button>
                                );
                            }
                        })}
                    </Box>
                )}
             </Box>
          </Box>
       );
   }

   // Old fallback
   return (
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
         {Array.isArray(image) && image.length === 2 ? (
            <Box position="relative" width="75%" maxWidth="500px" margin="2rem auto 3rem auto">
               {/* Laptop Screen */}
               <Box position="relative" border="12px solid #2b2b2b" borderBottom="none" borderRadius="16px 16px 0 0" overflow="hidden" boxShadow="0 20px 40px rgba(0,0,0,0.4)" background="#000">
                  <Box component={'img'} src={image[0]} alt={'desktop mockup'} style={{ width: '100%', display: 'block', aspectRatio: '16/9', objectFit: 'cover', objectPosition: 'top' }} />
               </Box>
               {/* Laptop Base */}
               <Box height="16px" background="#6c6c6c" borderRadius="0 0 16px 16px" position="relative" width="116%" left="-8%" boxShadow="inset 0 -3px 6px rgba(0,0,0,0.3), 0 15px 25px rgba(0,0,0,0.4)">
                  {/* Trackpad notch */}
                  <Box position="absolute" top="0" left="50%" sx={{transform: 'translateX(-50%)'}} width="80px" height="6px" background="#4a4a4a" borderRadius="0 0 6px 6px" />
               </Box>

               {/* Mobile Phone Screen */}
               <Box position="absolute" bottom="-15%" left="-10%" width="25%" minWidth="100px" border="6px solid #2b2b2b" borderRadius="24px" overflow="hidden" boxShadow="-10px 20px 30px rgba(0,0,0,0.5)" background="#000" zIndex={2}>
                  <Box component={'img'} src={image[1]} alt={'mobile mockup'} style={{ width: '100%', display: 'block', aspectRatio: '9/19.5', objectFit: 'cover', objectPosition: 'top' }} />
                  {/* Phone Notch */}
                  <Box position="absolute" top="0" left="50%" sx={{transform: 'translateX(-50%)'}} width="45%" height="14px" background="#2b2b2b" borderRadius="0 0 8px 8px" />
               </Box>
            </Box>
         ) : (
             <Box component={'img'} src={Array.isArray(image) ? image[0] : image} alt={'mockup'} style={{ maxWidth: '100%' }} />
         )}
         <h1 style={{fontSize: '2rem', marginTop: '1rem'}}>{title}</h1>
         <Box className={'portfolio'} display={'flex'} flexDirection={'row'} gap={'1rem'} flexWrap={'wrap'}
              justifyContent={'center'} alignItems={'center'} fontSize={'1.5rem'} py={'2rem'}>
            {Array.isArray(live) ? (
                live.map((item, index) => (
                    <Box key={index} p={1} border={'2px solid black'} borderRadius={'25px'}>
                        <IconLink link={item.link} title={item.title} icon={item.icon}/>
                    </Box>
                ))
            ) : live && (
                <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
                   <IconLink link={live} title={'Live Demo'} icon={'fa-brands fa-safari'}/>
                </Box>
            )}

            {source && (
                <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
                   <IconLink link={source} title={'Source Code'} icon={'fas fa-code'}/>
                </Box>
            )}
         </Box>
      </Box>
   );
}

export default PortfolioBlock;